import React from "react";
import { EvtSectionHeader } from "components/header";
import { EvtCoordinatorCard } from "components/coordinator/display-card";
import { useParams } from "react-router-dom";
import { ProjectClientCard } from "@/modules/work/projects/components/clientcard";
import { useProject } from "@/modules/work/projects/context";

export default function PeopleSection() {
  const { project_slug: projectSlug } = useParams();
  const { id } = useProject();

  return (
    <section className="mt-3.5">
      <EvtSectionHeader title="People" />
      <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 px-4 gap-4 md:px-6 mt-2.5">
        <EvtCoordinatorCard
          collection="projects"
          id={id}
          role="Project Coordinator"
          type="PROJECT_WITH_SLUG"
        />
        <EvtCoordinatorCard
          collection="projects"
          id={id}
          role="Account Manager"
          type="PROJECT_WITH_SLUG"
        />
        <EvtCoordinatorCard
          collection="projects"
          id={id}
          role="Sales Coordinator"
          type="PROJECT_WITH_SLUG"
        />
        <ProjectClientCard />
      </div>
    </section>
  );
}
